import vuexI18n from 'vuex-i18n'
import config from './config'
import constant from './constant'
import api from './modules/api'
import auth from './modules/auth'
import patient from './modules/patient'
import facility from './modules/facility'
import facilityDetail from './modules/facility-detail'
import facilityHistory from './modules/facility-history'
import careOffice from './modules/care-office'
import clinic from './modules/clinic'
import shop from './modules/shop'
import medicineInformation from './modules/medicine-information'
import patientInformation from './modules/patient-information'
import delivery from './modules/delivery'
import reportChange from './modules/report-change'
import doctor from './modules/doctor'
import careman from './modules/careman'
import phrase from './modules/phrase'
import plan from './modules/plan'
import print from './modules/print'
import address from './modules/address'
import reportHistory from './modules/report-history'
import reportBatchHistory from './modules/report-batch-history'
import medicine from './modules/medicine'
import user from './modules/user'
import report from './modules/report'
import reportEdit from './modules/report-edit'
import reportSend from './modules/report-send'
import pdfAddress from './modules/pdf-address'
import pdfHistory from './modules/pdf-history'
import image from './modules/image'
import notification from './modules/notification'
import monthlyCheck from './modules/monthly-check'
import nsipeReportEdit from './modules/nsips-report-edit'
import nsPatient from './modules/ns-patient'
import nsClinic from './modules/ns-clinic'
import nsDoctor from './modules/ns-doctor'
import nsCheck from './modules/ns-check'
import outpatient from './modules/outpatient'
import nsipsRelationSituationsList from './modules/nsips-relation-situations-list'

export default {
  state: {
    error: '',
    config: config,
    constant: constant
  },
  getters: {
    error: state => {
      return state.error
    },
    canManage: state => {
      var userType = state.auth.user.userType
      if (!userType) {
        userType = window.localStorage.getItem('user_type')
      }
      if (userType) {
        return !(userType === state.constant.userType.mi_careoffice || userType === state.constant.userType.mi_clinic || userType === state.constant.userType.mi_facility)
      } else {
        return false
      }
    },
    isFacility: state => {
      var userType = state.auth.user.userType
      if (!userType) {
        userType = window.localStorage.getItem('user_type')
      }
      return userType === state.constant.userType.mi_facility
    },
    isCareOffice: state => {
      var userType = state.auth.user.userType
      if (!userType) {
        userType = window.localStorage.getItem('user_type')
      }
      return userType === state.constant.userType.mi_careoffice
    },
    isClinic: state => {
      var userType = state.auth.user.userType
      if (!userType) {
        userType = window.localStorage.getItem('user_type')
      }
      return userType === state.constant.userType.mi_clinic
    }
  },
  modules: {
    api: api,
    i18n: vuexI18n.store,
    auth: auth,
    patient: patient,
    facility: facility,
    facilityDetail: facilityDetail,
    facilityHistory: facilityHistory,
    careOffice: careOffice,
    clinic: clinic,
    shop: shop,
    medicineInformation: medicineInformation,
    patientInformation: patientInformation,
    delivery: delivery,
    reportChange: reportChange,
    reportHistory: reportHistory,
    reportBatchHistory: reportBatchHistory,
    doctor: doctor,
    careman: careman,
    phrase: phrase,
    plan: plan,
    print: print,
    address: address,
    medicine: medicine,
    user: user,
    report: report,
    reportEdit: reportEdit,
    reportSend: reportSend,
    pdfAddress: pdfAddress,
    pdfHistory: pdfHistory,
    image: image,
    notification: notification,
    monthlyCheck: monthlyCheck,
    nsipeReportEdit: nsipeReportEdit,
    nsPatient: nsPatient,
    nsClinic: nsClinic,
    nsDoctor: nsDoctor,
    nsCheck: nsCheck,
    outpatient: outpatient,
    nsipsRelationSituationsList: nsipsRelationSituationsList
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js